export const conformiteFields = {
    typeOfVisit: null,
    typeOfInvestigation: null,
    typeOfControl: [],
    numeroRaccordementEuEp: [],
    numeroRaccordementEpEu: [],
    reseauSeparatif: null,
    surfaceParcelle: null,
    surfaceCollecte: null,
    derogationAccorde: null,
    proprieteNonRaccordeAssainissement: null,
    eauxPluvialeNonRaccordeAssainissement: null,
    raccordementEuEp: null,
    raccordementEuEpExistant: null,
    raccordementEuEpNew: null,
    estimatedNumberOfResident: null,
    raccordementEpEu: null,
    infiltrerPartieEP: null,
    recupererPartieEP: null,
    reconnecterEpGargouille: null,
    reconnecterEpExistEp: null,
    realisationBranchementEpNeuf: null,
    rejetDomestique: null,
    eauxUseesEtPluvialesSeparees: null,
    eauxUseesTransitentGouttiere: null,
    eauxUseesProlongeesEvents: null,
    eauxUseesRaccordeesRpu: null,
    etancheiteRespectee: null,
    sanitairesSiphonne: null,
    sanitairesSousNiveauChaussee: null,
    installationProtectionReflux: null,
    appareilsInterditReglement: null,
    appareilsInterditReglementText: null,
    gestionEpParcelle: null,
    gestionEpParcelleSelection: [],
    rejetDomestiqueBonFonctionnement: null,
    rejetDomestiqueAccessible: null,
    rejetDomestiqueEntretenu: null,
    rejetDomestiqueRemarque: null,
    rejetNonDomestique: null,
    activiteRestauration: null,
    activiteGarageLavage: null,
    parking: null,
    parkingNbPlace: null,
    autreActiviteNonDomestiques: null,
    autreActiviteNonDomestiquesText: null,
    equipementsPretraitement: null,
    equipementsPretraitementSelection: [],
    equipementsPretraitementAutre: null,
    rejetNonDomestiqueBonFonctionnement: null,
    rejetNonDomestiqueAccessible: null,
    rejetNonDomestiqueEntretenu: null,
    rejetNonDomestiqueRemarque: null,
    controleRemarque: null,
    controlStatus: null,
};
